import { Box, Table, TableBody, TableCell, TableRow, TableHeader } from 'grommet'
import React from 'react'


function EISResults(props) {


  return (
      <Box justify='center' align='center' pad='xsmall'>
        <h2>Esforços Internos Solicitantes</h2>
        <Table>
            <TableHeader>
                <TableRow>
                  <TableCell scope="col" border="bottom">
                    Barra
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    N1
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    V1
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    M1
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    N2
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    V2
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    M2
                  </TableCell>
                </TableRow>
              </TableHeader>
            <TableBody>
                {props.results.map((item, i) => {
                  return(
                    <TableRow>
                        <TableCell>
                        {i+1}
                      </TableCell>

                      <TableCell>
                        {item[0] < 0.0001 && item[0] > 0 ? 0 + " kN" : item[0].toFixed(2) + " kN"}
                      </TableCell>

                      <TableCell>
                        {item[1] < 0.0001 && item[1] > 0 ? 0 + " kN" : item[1].toFixed(2) + " kN"}
                      </TableCell>

                      <TableCell>
                        {item[2] < 0.0001 && item[2] > 0 ? 0 + " kN.m" : item[2].toFixed(2) + " kN.m"}
                      </TableCell>

                      <TableCell>
                        {item[3] < 0.0001 && item[3] > 0 ? 0 + " kN" : item[3].toFixed(2) + " kN"}
                      </TableCell>

                      <TableCell>
                        {item[4] < 0.0001 && item[4] > 0 ? 0 + " kN" : item[4].toFixed(2) + " kN"}
                      </TableCell>

                      <TableCell>
                        {item[5] < 0.0001 && item[5] > 0 ? 0 + " kN.m" : item[5].toFixed(2) + " kN.m"}
                      </TableCell>
                    </TableRow>
                  )})}
            </TableBody>
        </Table>
      </Box>
  )
}

export default EISResults